import {
  CHANGE_SEARCHFIELD,
  REQUEST_USERS_PENDING,
  REQUEST_USERS_SUCCESS,
  REQUEST_USERS_FAILED,
  GET_USER_PROFILE,
  GET_USER_PROFILE_ERROR,
  CREATE_USER_PROFILE_SUCCESS,
  CREATE_USER_PROFILE_FAILED,
  CREATE_USER_PROFILE_PENDING,
  EDIT_USER_PROFILE_SUCCESS,
} from "../constants/userConstants";
import Axios from "axios";
import { API_ROOT, API_ROOT1 } from "../components/utils/api-config";
import { setAlert } from "./alertAction";
let token = "Bearer " + localStorage.getItem("token");
const auth = {
  headers: {
    Authorization: token,
  },
};
export const setSearchField = (text) => ({
  type: CHANGE_SEARCHFIELD,
  payload: text,
});

export const requestUsers = () => (dispatch) => {
  dispatch({ type: REQUEST_USERS_PENDING });
  Axios.get(`${API_ROOT}/users/`, auth)
    .then((response) =>
      dispatch({ type: REQUEST_USERS_SUCCESS, payload: response.data })
    )
    .catch((error) => dispatch({ type: REQUEST_USERS_FAILED, payload: error }));
};

export const getUserProfile = (id) => (dispatch) => {
  Axios.get(`${API_ROOT}/users/${id}/`, auth)
    .then((response) =>
      dispatch({ type: GET_USER_PROFILE, payload: response.data })
    )
    .catch((error) =>
      dispatch({ type: GET_USER_PROFILE_ERROR, payload: error })
    );
};

export const postUser = (formData, config) => (dispatch) => {
  dispatch({ type: CREATE_USER_PROFILE_PENDING });
  Axios.post(`${API_ROOT}/users/`, formData, config)
    .then(({ data }) => {
      dispatch({
        type: CREATE_USER_PROFILE_SUCCESS,
        payload: data,
      });
      dispatch(setAlert("User account created", "success"));
      setTimeout(() => {
        // alert("User account created");
        window.location.replace(`${API_ROOT1}/sessions/new`);
      }, 1000);
    })
    .catch((error) => {
      dispatch({ type: CREATE_USER_PROFILE_FAILED, payload: error });
      dispatch(setAlert(JSON.stringify(error.response.data), "danger"));
    });
};
export const editUserProfile = (uzer) => (dispatch) => {
  dispatch({ type: EDIT_USER_PROFILE_SUCCESS, payload: uzer });
  dispatch(setAlert("User profile changed", "success"));
};
